import * as Business from '../business';
import * as UI       from '../ui';
import * as User     from '../user';
import { connect }   from 'react-redux';
import bail          from '../util/bail';
import React         from 'react';

class CheckAccess extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {};
  }

  static getDerivedStateFromProps(props) {
    return {
      urlWithoutBusiness: !props.businessID,
      noLocation:         !props.locationIDs || props.locationIDs.length === 0,
      canAccess:          props.isSalesforceUser || (props.roles && props.roles.length > 0)
    };
  }

  async componentDidMount() {
    await this.ensureAccess();
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.businessID !== this.props.businessID)
      await this.ensureAccess();
  }

  async ensureAccess() {
    const { urlWithoutBusiness } = this.state;
    if (urlWithoutBusiness)
      return;

    const { canAccess }  = this.state;
    const { noLocation } = this.state;
    if (canAccess)
      this.props.setBusinessID(this.props.businessID);
    else if (noLocation)
      bail();
    else {
      const locationID = this.props.locationIDs[0];
      this.props.toast('Location no longer available.');
      await this.props.setBusinessID(locationID);
      this.props.navigateTo(`/${locationID}/settings/location`, { reloadAll: true });
    }
  }

  render() {
    const { children }           = this.props;
    const { urlWithoutBusiness } = this.state;
    const { canAccess }          = this.state;

    if (urlWithoutBusiness || canAccess)
      return children;
    else
      return <div/>;
  }
}

export default connect(
  (state, { navigateTo, businessID }) => ({
    businessID,
    navigateTo,
    roles:            User.getRole(state, businessID),
    isSalesforceUser: User.isSalesforce(state),
    locationIDs:      User.getLocationIDs(state)
  }),
  dispatch => ({
    toast:         msg => dispatch(UI.toast(msg)),
    setBusinessID: businessID => dispatch(Business.setBusinessID(businessID))
  })
)(CheckAccess);
